module.exports = __webpack_public_path__ + "static/media/forwardhead_mild_right.dbb67eac.png";